// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2H2V22H22V2ZM6.5 8V6H17.5V8H6.5ZM12 9L16 14H13L13 18.5H11L11 14H8L12 9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-backtop-rectangle-filled')
export default class BacktopRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'backtop-rectangle-filled',
    }
  }
}
